



































































































import { Vue, Component, Ref } from 'vue-property-decorator'
import { obrigatorio } from '@/shareds/regras-de-form'
import { nextTick } from '@/shareds/utils'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import Confirmacao from '../ui/Confirmacao.vue'
import CampoDeTexto from '../ui/CampoDeTexto.vue'
import { Produto, Variante } from '@/models'

type AbaDoFornecedor = 'Principal' | 'Contatos' | 'Grupos Econômicos'

@Component({
	components: {
		Confirmacao,
		CampoDeTexto,
	},
})
export default class DialogoDeAdicionarCor extends Vue {
	@Ref() form!: HTMLFormElement
	@Ref() confirmacaoParaGerarVariantes!: Confirmacao
	$refs!: {
		[key: string]: HTMLFormElement | CampoDeTexto
	}
	salvando = false
	mostra = false
	obrigatorio = obrigatorio
	coresAdicionadas: any[] = []
	variantes: Variante[] = []

	async mostrar(produtoVariavel?: Produto) {
		this.variantes = produtoVariavel?.tipo === 'Com Variantes' ? produtoVariavel.variantes : []
		this.resetarDados()
		this.mostra = true
	}

	esconder() {
		this.mostra = false
		this.resetarDados()
	}

	resetarDados() {
		this.coresAdicionadas = []
	}

	async confirmarSelecao() {
		await nextTick()

		if (!this.coresAdicionadas || this.coresAdicionadas.length === 0) {
			AlertModule.setError('Informe ao menos uma cor para prosseguir')
			return
		}

		if (this.coresAdicionadas.filter(corAdicionada => corAdicionada.descricao === '' || !corAdicionada).length > 0) {
			AlertModule.setError('Existem cores em branco ou inválidas, verifique')
			return
		}

		const coresExistentes = this.variantes
			.flatMap(variantes => variantes.atributosVariante.map(attr => attr.valor?.toLowerCase().trim()))
			.filter(Boolean);

		const corDuplicada = this.coresAdicionadas.some(cor =>
			coresExistentes.includes(cor.descricao.toLowerCase().trim()),
		);

		if(corDuplicada) {
			AlertModule.setError('Você está tentando cadastrar uma cor que já está cadastrada para este produto, verifique!')
			return
		}

		this.coresAdicionadas.forEach(cor => {
			if (cor.descricao) {
				cor.descricao = cor.descricao.toUpperCase();
			}
		});
		
		if (await this.confirmacaoParaGerarVariantes.mostrarComParametros('Deseja gerar novas variantes deste produto?',
			`Cores: ${this.coresAdicionadas.map(cor => cor.descricao).join(', ')}`)) {
			try {
				this.salvando = true
				this.$emit('confirmado', this.coresAdicionadas.map(cor => cor.descricao))
				this.mostra = false
			} catch (error: any) {
				AlertModule.setError(error)
			} finally {
				this.salvando = false
			}
		}
	}

	async focarCor(indice) {
		setTimeout(() => {
			this.$refs[`cor-${indice}`][0].$children[0].focus()
		})
	}
}

